import { createSelector } from 'reselect';

import { userSelector } from './user';
import { channelDefaultRecipientSelector } from './channel';

import { isLoggedInWithUnlimitedTransfer } from '@app/helper/user';
import { UNLIMITED_TRANSFER_LIMIT } from '@app/constant/sizes';

const transfersSelector = (state) => state.transfers.list;
const transferSelector = (state) => state.transfer;

export const getAutoCompleteItems = createSelector(
  [transfersSelector],
  (transfers) => {
    return transfers
      .reduce((autoCompleteItems, transfer) => {
        const items = [...autoCompleteItems];

        // select transfer based on recipient email
        transfer.recipients.forEach((recipient) => {
          if (autoCompleteItems.indexOf(recipient.email) !== -1) return;
          items.push(recipient.email);
        });

        // select transfer based on file name
        transfer.files.forEach((file) => {
          if (autoCompleteItems.indexOf(file.name) !== -1) return;
          items.push(file.name);
        });
        return items;
      }, [])
      .map((item) => ({ label: item, id: item, spellings: item }));
  }
);

export const isSendingToDefaultRecipientSelector = createSelector(
  transferSelector,
  channelDefaultRecipientSelector,
  (transfer, channelDefaultRecipient) => {
    if (!channelDefaultRecipient) {
      return false;
    }

    if (transfer.recipients.length !== 1) {
      return false;
    }

    if (transfer.type !== 'email') {
      return false;
    }

    if (transfer.recipients[0] !== channelDefaultRecipient) {
      return false;
    }

    return true;
  }
);

export const allowedSizeSelector = createSelector(
  isSendingToDefaultRecipientSelector,
  userSelector,
  (isSendingToDefaultRecipient, user) => {
    if (isLoggedInWithUnlimitedTransfer(user)) {
      return UNLIMITED_TRANSFER_LIMIT;
    }

    const { transferLimitForDefaultRecipient, transferLimit } = user.rules;

    if (isSendingToDefaultRecipient) {
      return transferLimitForDefaultRecipient;
    }

    return transferLimit;
  }
);
